<template>
  <div class="date-select">
    <button v-if="showArrows" class="btn btn-default left" type="button" @click.prevent="prev()"><i class="fa fa-chevron-left"></i></button>
    <datepicker :value="date" language="sk" :monday-first="true" @input="dateChange" format="dd.MM.yyyy - D" input-class="form-control"></datepicker>
    <button v-if="showArrows" class="btn btn-default right" type="button" @click.prevent="next()"><i class="fa fa-chevron-right"></i></button>
  </div>
</template>

<script>
  import moment from 'moment';
  import datepicker from 'vuejs-datepicker';

  export default {
    components: { datepicker },
    data: () => ({
      date: null
    }),
    props: {
        value: {
            type: Object
        },
        showArrows: {
            type: Boolean,
            default: true
        }
    },
    methods: {
      dateChange(date) {
        this.date = moment.isMoment(date) ? date.toDate() : date;
        this.$emit('input', moment(this.date));
      },
      prev() {
        if (!this.date) this.date = date;
        this.dateChange(moment(this.date).subtract(1, 'd'));
      },
      next() {
        if (!this.date) this.date = date;
        this.dateChange(moment(this.date).add(1, 'd'));
      }
      },
    watch: {
      value(value) {
        this.date = value ? value.toDate() : null;
      }
    },
    mounted() {
      this.date = this.value && moment.isMoment(this.value) ? this.value.toDate() : null;
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/dateSelect.vue